import { IGetBiometriaUseCase } from "../../../presentation/useCases/read/get_biometria_use_case";

import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetBiometriaUseCase implements IGetBiometriaUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async getBiometria(
    idGestaoDistribuicaoEpi: number,
    nomeImagem: string,
  ): Promise<string> { 
    const rawBlob = await this.repository.getBiometria(idGestaoDistribuicaoEpi);
    if (!rawBlob) throw new Error("Falha ao buscar dados da imagem!");

    const imageBlob = new Blob([rawBlob], { type: 'image/jpeg' });
    
    return window.URL.createObjectURL(imageBlob); 
  }
}
